import { ShieldCheck, Zap, Globe } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { useI18n } from '@/lib/i18n'

interface Feature {
  titleKey: 'featPrivacyTitle' | 'featFastTitle' | 'featEdgeTitle'
  descKey: 'featPrivacyDesc' | 'featFastDesc' | 'featEdgeDesc'
  icon: LucideIcon
}

const FEATURES: readonly Feature[] = [
  { titleKey: 'featPrivacyTitle', descKey: 'featPrivacyDesc', icon: ShieldCheck },
  { titleKey: 'featFastTitle', descKey: 'featFastDesc', icon: Zap },
  { titleKey: 'featEdgeTitle', descKey: 'featEdgeDesc', icon: Globe },
]

/** Three-column value proposition. */
export function FeaturesSection() {
  const { t } = useI18n()

  return (
    <section className="mx-auto max-w-7xl px-4 py-24 sm:px-6 md:py-32 lg:px-8">
      <div className="grid gap-8 md:grid-cols-3">
        {FEATURES.map((feature) => (
          <div key={feature.titleKey} className="space-y-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <feature.icon className="h-6 w-6" aria-hidden />
            </span>
            <h3 className="text-xl font-semibold">{t(feature.titleKey)}</h3>
            <p className="text-base leading-relaxed text-muted-foreground">{t(feature.descKey)}</p>
          </div>
        ))}
      </div>
    </section>
  )
}